import { render, staticRenderFns } from "./TeacherQA.vue?vue&type=template&id=7e0466f2&"
import script from "./TeacherQA.vue?vue&type=script&lang=js&"
export * from "./TeacherQA.vue?vue&type=script&lang=js&"
import style0 from "./TeacherQA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports